export default function updateField(sheet, cellName, field, value, update) {
    if (update) {
        return (dispatch, getState) => {
            const { database } = getState().sheet
            const cell = database.headers.find(c => c.name === cellName)
            const ic = database.headers.indexOf(cell)
            const prevHeaders = database.headers
            prevHeaders[ic] = {...prevHeaders[ic], [field]: value}
            // const newHeader = [prevHeaders[ic]]
            // console.log("prec", prevHeaders)

            dispatch({
                type: 'UPDATE_DATABASE',
                headers: prevHeaders
            })
        }
    } else {
        return (dispatch, getState) => {
            dispatch({
                type: 'UPDATE_FIELD',
                sheet,
                cellName,
                field,
                value
            })
        }
    }
}
